/**
 * PAPPO — Reports service (denúncias). Usuário abre (/api/reports); staff
 * tria na fila do console (/api/staff/reports).
 */
import { apiGet, apiPost } from './api';

export type ReportReason =
  | 'assedio'
  | 'conteudo_improprio'
  | 'ameaca'
  | 'golpe'
  | 'aliciamento'
  | 'outro';
export type ReportStatus = 'aberta' | 'em_analise' | 'resolvida' | 'descartada';

export interface ReportListItem {
  id: number;
  reason: ReportReason;
  status: ReportStatus;
  created_at: string;
  reporter_name: string;
  reported_id: number;
  reported_name: string;
  reported_avatar: string | null;
  assigned_name: string | null;
  evidence_count: number;
}

export interface ReportDetail extends Omit<ReportListItem, 'evidence_count'> {
  description: string;
  resolution: string | null;
  resolved_at: string | null;
  resolved_name: string | null;
  evidence: string[];
}

export const REPORT_REASONS: { value: ReportReason; label: string }[] = [
  { value: 'assedio', label: 'Assédio' },
  { value: 'conteudo_improprio', label: 'Conteúdo impróprio' },
  { value: 'ameaca', label: 'Ameaça' },
  { value: 'golpe', label: 'Golpe / fraude' },
  { value: 'aliciamento', label: 'Aliciamento' },
  { value: 'outro', label: 'Outro' },
];

export const REASON_LABEL: Record<ReportReason, string> = Object.fromEntries(
  REPORT_REASONS.map((r) => [r.value, r.label])
) as Record<ReportReason, string>;

export const STATUS_LABEL: Record<ReportStatus, string> = {
  aberta: 'Aberta',
  em_analise: 'Em análise',
  resolvida: 'Resolvida',
  descartada: 'Descartada',
};

/** Usuário (responsável): abre uma denúncia com evidências (/uploads internos). */
export async function createReport(
  reported_id: number,
  reason: ReportReason,
  description: string,
  evidence_urls: string[]
) {
  return apiPost('/reports', { reported_id, reason, description, evidence_urls });
}

/** Staff: fila de denúncias (opcionalmente filtrada por status). */
export async function listReports(status?: ReportStatus) {
  return apiGet<{ reports: ReportListItem[] }>(
    status ? `/staff/reports?status=${status}` : '/staff/reports'
  );
}

/** Staff: detalhe de uma denúncia (com evidências). */
export async function getReport(id: number) {
  return apiGet<{ report: ReportDetail }>(`/staff/reports/${id}`);
}

/** Staff: atribuir a si (em_analise). */
export async function assignReport(id: number) {
  return apiPost(`/staff/reports/${id}/assign`, {});
}

/** Staff: encerrar (resolvida/descartada) com nota de resolução. */
export async function resolveReport(
  id: number,
  status: 'resolvida' | 'descartada',
  resolution: string
) {
  return apiPost(`/staff/reports/${id}/resolve`, { status, resolution });
}
